/**
 * Hook for fetching document sidebar data
 * 
 * Returns sidebar data including image, assigned users, attachments, tags,
 * likes, comments, follow status, and history.
 */

import { useQuery } from "@tanstack/react-query";
import { erp } from "@/lib/erp";

export function useDocSidebar(doctype: string, name: string | undefined) {
  return useQuery({
    queryKey: ["doc-sidebar", doctype, name],
    queryFn: () => erp.docs.getSidebar(doctype, name!),
    enabled: !!name,
    staleTime: 30_000, // 30 seconds - don't refetch aggressively while user is viewing
  });
}

